"use strict";
/** state: Experimental **/
/** family: Onboarding **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var popper_js_1 = require("popper.js");
var React = require("react");
var Backdrop_1 = require("../Backdrop");
var OnboardingPopover_1 = require("./OnboardingPopover");
var CLASS_NAME = 'i-onboarding';
/**
 * Onboarding groups many components together to produce simple onboarding patterns through 'tours'.
 *
 * Tours are used to introduce new features, or highlight existing unused functionality.
 */
var Onboarding = /** @class */ (function (_super) {
    __extends(Onboarding, _super);
    function Onboarding(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDismiss = function () {
            _this.handleEndTour();
            if (_this.props.onDismiss &&
                _this.state.currentStep < _this.props.steps.length - 1) {
                _this.props.onDismiss();
            }
        };
        _this.handleEndTour = function () {
            _this.setState({ currentStep: 0 }, function () {
                if (_this.props.onEnd) {
                    _this.props.onEnd(_this.state.targetElement);
                    _this.setState({ targetElement: null });
                }
            });
        };
        _this.handleNext = function () {
            var currentStep = _this.getStep();
            var currentTarget = document.querySelector(currentStep.selector);
            _this.setState({ targetElement: null });
            if (_this.props.onBeforeNext) {
                var returnValue = _this.props.onBeforeNext(currentTarget, _this.state.currentStep);
                // Do not proceed to the next step if onBeforeNext returns `false`.
                if (typeof returnValue === 'boolean' && !returnValue) {
                    return;
                }
            }
            if (currentStep.onAfter) {
                currentStep.onAfter(currentTarget, _this.state.currentStep);
            }
            _this.setState({ currentStep: _this.state.currentStep + 1 }, function () {
                var nextStep = _this.getStep();
                var nextTarget = document.querySelector(nextStep.selector);
                if (nextStep.onBefore) {
                    nextStep.onBefore(nextTarget, _this.state.currentStep);
                }
                _this.props.onAfterNext &&
                    _this.props.onAfterNext(nextTarget, _this.state.currentStep);
            });
        };
        _this.getStep = function () { return _this.props.steps[_this.state.currentStep]; };
        _this.getVisibleTarget = function () {
            var target = document.querySelector(_this.getStep().selector);
            if (target) {
                if (target.scrollIntoViewIfNeeded) {
                    target.scrollIntoViewIfNeeded();
                    return target;
                }
                var rect = target.getBoundingClientRect();
                var html = document.documentElement;
                if (rect.top < 0 ||
                    rect.left < 0 ||
                    rect.bottom > (window.innerHeight || html.clientHeight) ||
                    rect.right > (window.innerWidth || html.clientWidth)) {
                    target.scrollIntoView();
                }
                return target;
            }
            return null;
        };
        _this.handleFocus = function () {
            var onboardingStepElement = document.querySelector("." + CLASS_NAME + "__popover");
            var currentElement = document.activeElement;
            if (onboardingStepElement.contains(currentElement)) {
                currentElement.focus();
            }
            else {
                onboardingStepElement.focus();
            }
        };
        _this.setTarget = function () {
            var step = _this.getStep();
            if (!_this.state.targetElement) {
                // Try to find the target.
                var targetElement = _this.getVisibleTarget();
                if (targetElement) {
                    _this.setState({ targetElement: targetElement });
                }
                else {
                    if (step.skipIfTargetMissing) {
                        if (_this.state.currentStep >= _this.props.steps.length - 1) {
                            _this.handleEndTour();
                        }
                        else {
                            _this.handleNext();
                        }
                        return;
                    }
                    console.warn("Can't find the element specified by the selector \"" + step.selector + "\".");
                    // Wait and try again, and again, and again...
                    var targetStep_1 = _this.state.currentStep;
                    var interval_1 = setInterval(function () {
                        var visibleTarget = _this.getVisibleTarget();
                        if (visibleTarget) {
                            _this.setState({ targetElement: visibleTarget });
                            clearInterval(interval_1);
                        }
                        if (targetStep_1 !== _this.state.currentStep) {
                            clearInterval(interval_1);
                        }
                    }, _this.props.retry);
                }
            }
        };
        _this.cleanup = function () {
            if (_this.focusEventListener) {
                _this.focusEventListener.remove();
            }
            if (_this.popper) {
                _this.popper.destroy();
                _this.popper = null;
            }
        };
        _this.state = {
            currentStep: props.step || 0,
            isMounted: false,
            targetElement: null,
        };
        return _this;
    }
    Onboarding.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.setState({ isMounted: true }, function () {
                var step0 = _this.props.steps[0];
                if (step0.onBefore) {
                    step0.onBefore(document.querySelector(step0.selector), 0);
                }
                _this.focusNextActionButton();
            });
        }, this.props.delay);
    };
    Onboarding.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.step != null &&
            nextProps.step !== this.state.currentStep) {
            this.setState({ targetElement: null, currentStep: nextProps.step });
        }
        if (!nextProps.active && this.props.active) {
            this.addFocusListener();
        }
        else if (nextProps.active && !this.props.active) {
            this.cleanup();
        }
    };
    Onboarding.prototype.componentDidUpdate = function (_, prevState) {
        this.setTarget();
        this.focusNextActionButton();
        // the step doesn't have a target, so destroy the popper
        if (this.popper != null &&
            this.state.targetElement == null &&
            prevState.targetElement != null) {
            this.popper.destroy();
        }
        // the target element has changed, update the popper
        if (this.state.targetElement != null &&
            this.popover != null &&
            (this.popper == null ||
                this.state.targetElement !== prevState.targetElement)) {
            if (this.popper) {
                this.popper.destroy();
            }
            var placement = this.getStep().placement;
            this.popper = new popper_js_1.default(this.state.targetElement, this.popover, placement && {
                placement: placement,
            });
        }
    };
    Onboarding.prototype.componentWillUnmount = function () {
        this.cleanup();
    };
    Onboarding.prototype.render = function () {
        var _this = this;
        var step = this.getStep();
        return (this.props.active &&
            this.state.isMounted && (React.createElement("div", { className: classNames(CLASS_NAME, this.props.className) },
            React.createElement(Backdrop_1.Backdrop, { active: true, isTinted: true }),
            React.createElement(OnboardingPopover_1.OnboardingPopover, { arrow: this.state.targetElement != null, closeLabel: this.props.endTourActionLabel, endLabel: step.endStepActionLabel ||
                    this.props.endStepActionLabel, heading: step.heading, instance: function (ref) { return (_this.popover = ref); }, message: step.message, nextLabel: step.nextStepActionLabel ||
                    this.props.nextStepActionLabel, onDismiss: this.handleDismiss, onEnd: this.handleEndTour, onNext: this.handleNext, stepCount: this.props.steps.length, stepIndex: this.state.currentStep }))));
    };
    Onboarding.prototype.focusNextActionButton = function () {
        var nextBtn = document.querySelector("." + CLASS_NAME + "__popover__actions__button");
        if (nextBtn) {
            setTimeout(function () {
                nextBtn.focus();
            });
        }
    };
    Onboarding.prototype.addFocusListener = function () {
        var _this = this;
        if (!this.focusEventListener) {
            document.body.addEventListener('focus', this.handleFocus, true);
            this.focusEventListener = {
                remove: function () {
                    _this.focusEventListener = null;
                    document.body.removeEventListener('focus', _this.handleFocus, true);
                },
            };
        }
    };
    Onboarding.Popover = OnboardingPopover_1.OnboardingPopover;
    Onboarding.defaultProps = {
        delay: 0,
        retry: 500,
    };
    return Onboarding;
}(React.Component));
exports.Onboarding = Onboarding;
//# sourceMappingURL=Onboarding.js.map